import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import './LegalPage.css';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="legal-page">
      <Navbar />
      <div className="legal-page__hero">
        <div className="container">
          <span className="section-label">Legal</span>
          <h1 className="legal-page__title">Términos y Condiciones</h1>
          <p className="legal-page__subtitle">Última actualización: junio 2025</p>
        </div>
      </div>

      <div className="container legal-page__body">
        <div className="legal-page__content">

          <section className="legal-section">
            <h2>1. Aceptación de los términos</h2>
            <p>
              Al acceder y utilizar el sitio web de <strong>Consuprog</strong> (consuprog.com),
              usted acepta quedar vinculado por estos Términos y Condiciones. Si no está de acuerdo
              con alguno de los términos, le pedimos que no utilice este sitio.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Carácter informativo del sitio</h2>
            <p>
              Este sitio web tiene carácter exclusivamente <strong>informativo</strong>. Los proyectos,
              imágenes, descripciones y servicios mostrados son referenciales y no constituyen una oferta
              contractual, propuesta formal ni compromiso de precio o plazo.
            </p>
            <p>
              Toda cotización, propuesta técnica o acuerdo debe ser negociado y firmado formalmente
              entre las partes involucradas.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Propiedad intelectual</h2>
            <p>
              Todo el contenido de este sitio — incluyendo textos, imágenes, logotipos, diseño y
              fotografías de proyectos — es propiedad de Consuprog o se utiliza con autorización.
              Queda prohibida su reproducción, distribución o uso sin autorización expresa y escrita
              de la Empresa.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Uso del formulario de contacto</h2>
            <p>
              Al enviar el formulario de contacto usted autoriza a Consuprog a utilizar la información
              proporcionada para responder a su consulta. El envío del formulario no genera ninguna
              obligación contractual para ninguna de las partes.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Limitación de responsabilidad</h2>
            <p>Consuprog no se hace responsable por:</p>
            <ul>
              <li>Errores u omisiones en el contenido del sitio</li>
              <li>Interrupciones o fallos técnicos del sitio web</li>
              <li>Decisiones tomadas basándose en la información publicada sin verificación previa</li>
              <li>Daños derivados del uso indebido del sitio o sus contenidos</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Enlaces externos</h2>
            <p>
              Este sitio puede contener enlaces a sitios de terceros (redes sociales, WhatsApp, etc.).
              Consuprog no controla ni es responsable del contenido, políticas o prácticas de dichos
              sitios externos.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Modificaciones</h2>
            <p>
              Consuprog se reserva el derecho de modificar estos Términos y Condiciones en cualquier
              momento. Los cambios serán efectivos desde su publicación en esta página. El uso
              continuado del sitio implica la aceptación de los términos vigentes.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Legislación aplicable</h2>
            <p>
              Estos Términos y Condiciones se rigen por las leyes de la República de Honduras.
              Cualquier controversia derivada del uso de este sitio será sometida a los tribunales
              competentes de Tegucigalpa, Honduras.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contacto</h2>
            <p>
              Para cualquier consulta relacionada con estos términos, puede contactarnos en:{' '}
              <a href="mailto:GerenciaConsuprog@consuprog.com">GerenciaConsuprog@consuprog.com</a>
            </p>
          </section>

          <div className="legal-page__back">
            <Link to="/" className="btn-back">← Volver al inicio</Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
